import { render, staticRenderFns } from "./FilesListVirtual.vue?vue&type=template&id=0134ce5c&scoped=true"
import script from "./FilesListVirtual.vue?vue&type=script&lang=ts"
export * from "./FilesListVirtual.vue?vue&type=script&lang=ts"
import style0 from "./FilesListVirtual.vue?vue&type=style&index=0&id=0134ce5c&prod&scoped=true&lang=scss"
import style1 from "./FilesListVirtual.vue?vue&type=style&index=1&id=0134ce5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134ce5c",
  null
  
)

export default component.exports